import {
  CLEAR_PROPOSAL,
  SEND_PROPOSAL,
  SEND_PROPOSAL_SUCCESS,
  SEND_PROPOSAL_ERROR,
} from '../constants/proposal';

const PROPOSAL_INIT = {
  response: {
    mensagens: [],
  },
  proposal: false,
  loading: false,
  error: false,
  errors: [],
};

export default (state = PROPOSAL_INIT, action) => {
  switch (action.type) {
    case CLEAR_PROPOSAL:
      return {
        ...state,
        proposal: false,
        error: false,
        errors: [],
      };
    case SEND_PROPOSAL:
      return {
        ...state,
        loading: true,
        error: false,
        errors: [],
      };
    case SEND_PROPOSAL_SUCCESS:
      return {
        ...state,
        proposal: true,
        loading: false,
        response: action.payload,
      };
    case SEND_PROPOSAL_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        errors: action.payload,
      };
    default:
      return state;
  }
};
